<ng-container *ngIf="viewModel$ | async as vm">
  <div class="sticky-step-navigation">
    <div class="buttons-container" [class.has-previous]="vm.previousButton">
      <p-button
        *ngIf="vm.previousButton"
        class="previous-step-button-wrapper"
        [label]="vm.previousButton.label"
        [icon]="vm.previousButton.icon"
        outlined="true"
        styleClass="previous-step-button"
        (onClick)="
          store.dispatch(
            actions.previousStepButtonClicked({ currentStep: vm.step })
          )
        "
      ></p-button>

      <div class="next-step-area" [class.has-warning]="vm.nextButtonErrors.length">
        <div class="continue-warning-box" *ngIf="vm.nextButtonErrors.length">
          <i class="pi pi-exclamation-triangle warning-icon"></i>
          <ul class="warning-errors">
            <li *ngFor="let error of vm.nextButtonErrors">{{ error }}</li>
          </ul>
        </div>
        <p-button
          class="next-step-button-wrapper"
          [label]="vm.nextButton.label"
          [icon]="vm.nextButton.icon"
          [iconPos]="vm.nextButton.iconPos"
          [styleClass]="vm.nextButton.styleClass"
          [disabled]="vm.nextButtonDisabled"
          (onClick)="
            store.dispatch(
              actions.nextStepButtonClicked({ currentStep: vm.step })
            )
          "
        ></p-button>
      </div>
    </div>
  </div>
</ng-container>
